<bmcore-genres-slider [popularGenres]="popularGenres"></bmcore-genres-slider>
